import React from 'react';
import Title from 'components/UI/Title';
import ResetPasswordForm from 'components/Forms/Members/ResetPasswordForm';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

function ResetPasswordPage({ isB2cPage })
{
    return (
        <div className="tw-flex tw-flex-col tw-min-h-screen tw-items-center tw-justify-center tw-w-full tw-overflow-y-auto tw-box-content">

            <Title title="Reset your password" className="primary" />

            <div className="tw-flex tw-flex-col tw-bg-white dark:tw-bg-neutral-700 tw-rounded tw-p-3 lg:tw-w-2/5 md:tw-w-2/3 tw-w-5/6">

                <div className="tw-flex-col">
                    <ResetPasswordForm />
                </div>
            </div>
            <Helmet title={`Reset Password | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Reset Password" />
            </Helmet>
        </div>
    );
}

ResetPasswordPage.defaultProps = {
    isB2cPage: false,
};

ResetPasswordPage.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default ResetPasswordPage;
